<template>
  <div :class="{ footer: true, big: big }">
    <div :class="{ mainCenter: true }">
      <ul>
        <li class="clearfix">
          <!--  <div class="left fl">
                        <a href="javaScript:">关于源石</a>
                        <span>|</span>
                        <a href="javaScript:">奖励计划</a>
                        <span>|</span>
                        <a href="javaScript:">联系我们</a>
                        <span>|</span>
                        <a href="javaScript:">成为作者</a>
                    </div> -->
        </li>
        <li class="clearfix">
          <!--          <div class="left fl">-->
          <!--            客服邮箱：kefu@jumengxinxi.com 电话：010-82156292 QQ：2984543729-->
          <!--            2814551419-->
          <!--          </div>-->
          <a
            style="font-size:14px;cursor:pointer;margin-left: 14px;"
            target="_blank"
            href="https://www.byzww.net/images/wen.png"
            class="right"
            >客服邮箱：kefu@jinmajuchang.com
          </a>
          <span style="font-size:14px;cursor:pointer">
            客服电话：010-686 23209
          </span>
          <!--          <a-->
          <!--            style="font-size:14px;cursor:pointer;margin-right:15px;display:inline-block"-->
          <!--            target="_blank"-->
          <!--            href="https://jumengxinxi.com/cert/chubw.jpg"-->
          <!--            class="right fr"-->
          <!--            >出版物经营许可证</a-->
          <!--          >-->
        </li>
        <li class="clearfix">
        

          <!--          <div class="right fr">-->
          <!--            Copyright jumengxinxi.com All rights reserved.-->
          <!--          </div>-->
        </li>
        <li class="clearfix">
          <div class="left">
            <!-- <a
              style="font-size:14px;cursor:pointer"
              href="https://img.yuanshixx.cn/cert/icp.jpg?tdsourcetag=s_pctim_aiomsg"
              >粤B2-20191449</a
            > -->
            <a
              style="font-size:14px;cursor:pointer;margin-left:15px"
              target="_blank"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              >蜀ICP备2023004248号-4</a
            >
           
            <!--            <a-->
            <!--                    target="_blank"-->
            <!--                    style="font-size:14px;cursor:pointer;margin-left:15px"-->
            <!--                    href="http://www.jumengxinxi.com/images/ICP.png"-->
            <!--            >粤B2-2019149</a-->
            <!--            >-->
          </div>
        </li>
        <li class="clearfix">
          <div class="left">
            <!-- <a
              style="font-size:14px;cursor:pointer"
              href="https://img.yuanshixx.cn/cert/icp.jpg?tdsourcetag=s_pctim_aiomsg"
              >粤B2-20191449</a
            > -->
         
            <a
              style="font-size:14px;cursor:pointer;margin-left:15px"
              :href="require('../../assets/guangdian.png')"
              target="_blank"
              >广播电视节目制作经营许可证 （川）字第成0387号</a
            >
            <!--            <a-->
            <!--                    target="_blank"-->
            <!--                    style="font-size:14px;cursor:pointer;margin-left:15px"-->
            <!--                    href="http://www.jumengxinxi.com/images/ICP.png"-->
            <!--            >粤B2-2019149</a-->
            <!--            >-->
          </div>
        </li>
        <li class="clearfix">
          <div class="left">
            <!-- <a
              style="font-size:14px;cursor:pointer"
              href="https://img.yuanshixx.cn/cert/icp.jpg?tdsourcetag=s_pctim_aiomsg"
              >粤B2-20191449</a
            > -->
         
            <a
              style="font-size:14px;cursor:pointer;margin-left:15px"
              :href="require('../../assets/wwz.jpg')"
              target="_blank"
              >网络文化经营许可证&nbsp;（川）网文(2023)4393-293号</a
            >
            <!--            <a-->
            <!--                    target="_blank"-->
            <!--                    style="font-size:14px;cursor:pointer;margin-left:15px"-->
            <!--                    href="http://www.jumengxinxi.com/images/ICP.png"-->
            <!--            >粤B2-2019149</a-->
            <!--            >-->
          </div>
        </li>
        <li class="clearfix">
          <div class="left">
            <!-- <a
              style="font-size:14px;cursor:pointer"
              href="https://img.yuanshixx.cn/cert/icp.jpg?tdsourcetag=s_pctim_aiomsg"
              >粤B2-20191449</a
            > -->
         
            <a
              style="font-size:14px;cursor:pointer;margin-left:15px"
              :href="require('../../assets/ICP.jpg')"
              target="_blank"
              >增值电信业务经营许可证&nbsp;（川）B2-20231702</a
            >
            <!--            <a-->
            <!--                    target="_blank"-->
            <!--                    style="font-size:14px;cursor:pointer;margin-left:15px"-->
            <!--                    href="http://www.jumengxinxi.com/images/ICP.png"-->
            <!--            >粤B2-2019149</a-->
            <!--            >-->
          </div>
        </li>
        <li class="clearfix">
          <!-- <div class="lef fl">出版物经营许可证 新出发京零字第海 140576号</div> -->
          <div class="right">
            <a
              style="font-size:14px;cursor:pointer;margin-left:15px"
              :href="require('../../assets/zhizhao.png')"
              target="_blank"
              >成都金马驹文化科技有限公司</a
            >

            地址：四川省成都市天府新区煎茶街道鸿湘寺下街1号
          </div>
          <!--          <div class="right fr">-->
          <!--            <a-->
          <!--              target="_blank"-->
          <!--              style="font-size:14px;cursor:pointer"-->
          <!--              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502039759"-->
          <!--            >-->
          <!--              <img style="width:18px;height:18px" src="~img/beian.png" alt="" />-->
          <!--              京公网安备 11010502039759号-->
          <!--            </a>-->
          <!--          </div>-->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    big: Boolean,
  },
  data() {
    return {
      fixed: false,
      // domainUrl: 'www.yuanshixx.com',
      filingNum: 6,
    };
  },
  mounted() {
    // this.domainUrl = window.location.host
    if (
      window.location.host == "jumengxinxi.com" ||
      window.location.host == "www.jumengxinxi.com"
    ) {
      this.filingNum = 7;
    } else if (
      window.location.host == "jumengxx.com" ||
      window.location.host == "www.jumengxx.com"
    ) {
      this.filingNum = 6;
    } else if (
      window.location.host == "2zhoumu.com" ||
      window.location.host == "www.2zhoumu.com"
    ) {
      this.filingNum = 9;
    } else if (
      window.location.host == "2zhoumumh.com" ||
      window.location.host == "www.2zhoumumh.com"
    ) {
      this.filingNum = 12;
    }
  },
};
</script>

<style lang="stylus" scoped>
.footer
    background rgba(242, 242, 242, 1)
    padding 28px 0 31px
    line-height 20px
    margin-top 10px
    width 100%
    &.big
        background rgba(25, 31, 69, 1)
        .mainCenter
            width 1200px
            color #BCBCBC
            a
                color #BCBCBC
                font-size 18px
    &.fixed
        position fixed
        bottom 0
        left 0
    .mainCenter
        width 1016px
        margin 0 auto
        color #666666
        font-size 14px
        li
            margin 0 0 15px
            &:last-child
                margin-bottom 0
            a
                font-size 14px
                cursor pointer
        a
            color #666666
            font-size 18px
        span
            font-size 18px
            display inline-block
            margin 0 5px
        img
            width 56px
            height 21px
</style>
